<template>
  <div class="main-container" style="margin-top: 10px">
    <div class="bi-title">研究报告</div>
    <div class="card-head-line"></div>
    <div class="card-head-nav" v-if="userPlatform !==2 ">
      <div
        v-for="item in navList"
        :key="item.id"
        :class="['card-head-nav-item', activeClass(item.id)]"
        @click="navClick(item.id)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="card-module-container">

      <div  class="card-thrid-item card-module-normal">
        <div v-if="userPlatform ===2 " class="thrid-item-title">周报</div>

        <div v-show="reportCardShow(1)" class="card-box" @click="toRegister">
          <div
            v-for="item in weekReportList"
            :key="item.fileId"
            class="normal-item"
          >
            <div class="content">{{ item.fileName }}</div>
            <div class="aside">{{ item.addTime }}</div>
          </div>
        </div>
      </div>

      <div class="card-thrid-item card-module-normal">
        <div v-if="userPlatform ===2 " class="thrid-item-title">月报</div>
        <div v-show="reportCardShow(2)" class="card-box" @click="toRegister">
          <div
            v-for="item in monthReportList"
            :key="item.fileId"
            class="normal-item"
          >
            <div class="content">{{ item.fileName }}</div>
            <div class="aside">{{ item.addTime }}</div>
          </div>
        </div>
      </div>

      <div class="card-thrid-item card-module-normal">
        <div v-if="userPlatform ===2 " class="thrid-item-title">年报</div>

        <div v-show="reportCardShow(3)" class="card-box" @click="toRegister">
          <div
            v-for="item in yearReportList"
            :key="item.fileId"
            class="normal-item"
          >
            <div class="content">{{ item.fileName }}</div>
            <div class="aside">{{ item.addTime }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    weekReportList: {
      type: Array,
      default: () => [],
    },
    monthReportList: {
      type: Array,
      default: () => [],
    },
    yearReportList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeId: 1,
      navList: [
        {
          id: 1,
          title: "周报",
        },
        {
          id: 2,
          title: "月报",
        },
        {
          id: 3,
          title: "年报",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userPlatform: (state) => state.user.userPlatform,
    }),
    reportCardShow(){
      return (itemId)=>{
        if(this.userPlatform !== 2){
          if(this.activeId === itemId){
            return true
          }
          return false
        }else {
          return true
        }
      }
    },
    activeClass() {
      return (itemId) => {
        if (itemId === this.activeId) {
          return "card-head-nav-active-item";
        }
        return "";
      };
    },
  },

  methods: {
    navClick(itemId) {
      if (itemId === this.activeId) {
        return;
      }
      this.activeId = itemId;
    },
    toRegister() {
      this.$emit("toRegister");
    },
  },
};
</script>

<style lang="scss" scoped >
.card-head-nav {
  display: flex;
  padding: 20px 0;

  .card-head-nav-item {
    min-width: 5rem;
    width: 5rem;
    text-align: center;
    color: #2b304d;
    border: 1px solid #2b304d;
  }
  .card-head-nav-item:not(:first-of-type) {
    border-left: none;
  }

  .card-head-nav-active-item {
    background-color: #ffffff;

    background-color: #2b304d;
    color: #ffffff;
  }
}

.card-module-container {
  // width: 1200px;
  width: 100%;
  margin: auto;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 10px;
  font-size: 14px;
  overflow: hidden;

  .card-thrid-item {
    width: 100%;
    transition: all 250ms ease-in-out;
    .thrid-item-title {
      font-size: 18px;
      
      font-weight: 400;
      color: #333333;
      padding: 8px 0;
    }

    .card-box {
      height: 285px;
      overflow: hidden;
      width: 100%;
      overflow: hidden;
      border: 1px solid #dcdfe6;
    }
  }

  .card-module-normal {
    .card-box {
      .normal-item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0 10px;
        color: #303133;
        .haschild-content {
          flex-basis: 1;
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          display: flex;
          align-items: center;

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .content {
          flex-basis: 1;
          flex-grow: 1;
          // max-width
          // max-width: calc(100% - 7rem);
          // min-width: calc(100% - 7rem);

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .aside {
          height: 1.2rem;
          line-height: 1.2rem;
          min-width: 4rem;
          width: 4rem;
          text-align: right;
          font-size: 14px;
          font-weight: 400;
          color: #909399;
          overflow: hidden;
        }
      }
      .normal-item:nth-of-type(even) {
        background: #f8f8f9;
      }
    }
  }
}

@media (min-width: 1280px) {
  .card-module-normal {
    .card-box {
      .normal-item {
        .aside {
          min-width: 6rem;
          width: 6rem;
        }
      }
    }
  }
  .card-module-container {
    width: 1200px;
    padding: 10px 0;

    .card-thrid-item {
      min-width: 386px;
      width: 386px;
    }
  }
}
</style>